module.exports = __webpack_public_path__ + "static/media/appDownloadButton_android@2x.3e8bd2bd.png";